const sv = {
  'nav.browse': 'Bläddra',
  'nav.home': 'Hem',
  'nav.settings': 'Inställningar',
  'nav.genres': 'Genrer',
  'nav.history': 'Historik',
  'nav.support': 'Support',
  'nav.devices': 'Enheter',
  'nav.prism': 'Remaster',
  'devices.title': 'Enheter',
  'devices.subtitle': 'Konfigurera dina ljudzoner',
  'devices.verification_explainer_toggle': 'Så fungerar verifiering ▸',
  'devices.verification_explainer_heading': 'Så fungerar verifiering',
  'devices.verification_explainer_collapse': 'Dölj',
  'devices.verified_formats_pending': 'Formatuppgifter fylls på när fler lyssnare spelar på den här enheten',
  'devices.verified_match_badge': 'Verifierad',
  'verified.title': 'Maestro Verified',
  'verified.badge': 'Maestro Verified',
  'verified.badge_title': 'Den här enheten är verifierad att fungera med Maestro',
  'verified.header_subtitle': 'Verifierad för bit-perfekt uppspelning. Varje enhet på listan har uppfyllt Maestros verifieringsstandard för uppspelning, bekräftad med mätningar och övervakad kontinuerligt.',
  'verified.header_count': '{count} enheter verifierade',
  'verified.search_placeholder': 'Sök efter enhet eller tillverkare…',
  'verified.verified_as_of': 'Verifierad den {date}',
  'verified.stale_note': 'Visar den senast sparade listan — vi uppdaterar när anslutningen är tillbaka.',
  'verified.empty_search': 'Hittar du inte din? Om den spelar uppdateras listan automatiskt när enheter bevisar sig i fältet.',
  'verified.empty_list': 'Verifierade enheter visas här när lyssnare bekräftar dem i fältet.',
  'verified.view_list': 'Visa Maestro Verified-enheter',
  'verified.entry_subtitle': '{count} enheter och fler på väg',
  'verified.brand_subtitle': 'Märke verifierat — {transports}',
  'verified.verified_month': 'Verifierad {date}',
  'verified.picker_link': 'Är min enhet verifierad?',
  'help.verified_label': 'Maestro Verified',
  'help.verified_desc': 'Bläddra bland ljudenheter som bekräftats fungera med Maestro i riktiga hem och system.',
  'nav.services': 'Tjänster',
  'nav.playlists': 'Spellistor',
  'nav.my_playlists': 'Mina spellistor',
  'nav.favorites': 'Favoriter',
  'nav.audiophile': 'Highend-demomusik',
  'nav.genre_playlists': 'Stilspellistor',
  'nav.mood_playlists': 'Stämningsspellistor',
  'nav.season_playlists': 'Säsongsspellistor',
  'nav.discover': 'Upptäck',
  'nav.valet_picks': '{valetName}s val',
  'nav.trending': 'Trendande',
  'nav.new_releases': 'Nyheter',
  'nav.community': 'Community',
  'valet.community.subtitle': 'Se vad Maestro-communityn lyssnar på',
  'valet.community.empty': 'Communityns lyssnarstatistik visas här när fler medlemmar spelar musik den här veckan.',
  'valet.community.error': 'Communitystatistik är tillfälligt otillgänglig.',
  'valet.community.activeThisWeek': 'Aktiva den här veckan',
  'valet.community.listenersLabel': 'lyssnare',
  'valet.community.tracksPlayed': 'Spelade spår',
  'valet.community.thisWeek': 'den här veckan',
  'valet.community.artistsDiscovered': 'Upptäckta artister',
  'valet.community.uniqueArtists': 'unika artister',
  'valet.community.avgSession': 'Snittsession',
  'valet.community.listeningTime': 'lyssnartid',
  'valet.community.topArtistsTitle': 'Toppartister den här veckan',
  'valet.community.privacyNote': 'All communitydata är anonym och aggregerad. Individuella lyssnarvanor delas aldrig.',
  'valet.forYou.subtitle': 'Personliga val utifrån din smak',
  'valet.forYou.signInTitle': 'Logga in för personliga val',
  'valet.forYou.signInBody': '{valetName} behöver ett inloggat konto för att lära sig din smak och föreslå musik just för dig.',
  'valet.forYou.signInButton': 'Logga in',
  'valet.forYou.loadError': 'Kunde inte ladda rekommendationer just nu.',
  'valet.forYou.empty': 'Börja lyssna så att {valetName} lär sig din smak.',
  'valet.forYou.noMatches': 'Inga träffar',
  'valet.forYou.adjustFilters': 'Prova att justera filtren',
  'valet.forYou.clearFilters': 'Rensa filter',
  'valet.forYou.feedbackHint': 'Håll muspekaren över en rekommendation för att ge feedback och hjälpa {valetName} lära sig dina preferenser',
  'nav.personalize': 'Anpassa',
  'nav.my_library': 'Mitt bibliotek',
  'nav.your_library': 'Ditt bibliotek',
  'nav.local_library': 'Lokalt bibliotek',
  'nav.my_music': 'Min strömmade musik',
  'nav.local_files': 'Mina lokala filer',
  'nav.tools': 'Verktyg',
  'nav.recently_played': 'Nyligen spelade',
  'nav.manage': 'Hantera',
  'nav.local': 'Lokalt',
  'nav.albums': 'Mina album',
  'nav.library': 'Bibliotek',
  'nav.artists': 'Mina artister',
  'nav.lib_playlists': 'Spellistor',
  'nav.lib_albums': 'Album',
  'nav.lib_artists': 'Artister',
  'nav.tracks': 'Spår',
  'nav.composers': 'Kompositörer',
  'nav.my_live_radio': 'Min live-radio',
  'nav.folders': 'Mappar',
  'nav.standard': 'Standard',
  'nav.full_featured': 'Fullt utrustad',
  'help.local_features': 'Bibliotek och nätverksspelare',
  'trackMenu.removeFromPlaylist': 'Ta bort från spellista',
  'trackMenu.playNow': 'Spela nu',
  'trackMenu.playNext': 'Spela härnäst',
  'trackMenu.playOnlyThisTrack': 'Spela bara det här spåret',
  'trackMenu.addToQueue': 'Lägg till i kön',
  'settings.dark_mode': 'Mörkt läge',
  'settings.dark_mode_desc': 'Växla mellan ljust och mörkt tema',
  'settings.theme': 'Tema',
  'settings.theme_desc': 'Välj din visuella stil',
  'settings.theme_light': 'Ljust',
  'settings.theme_dark': 'Mörkt',
  'settings.theme_high_contrast': 'Hög kontrast',
  'settings.display_size': 'Visningsstorlek',
  'settings.display_size_desc': 'Skala gränssnittet efter din skärm',
  'settings.size_small': 'Liten',
  'settings.size_default': 'Standard',
  'settings.size_large': 'Stor',
  'settings.size_xl': 'Extra stor',
  'home.jukebox_title': 'Ellas jukebox',
  'home.jukebox_desc': '30 album du inte hört på ett tag, spelade album för album',
  'home.jukebox_loading': 'Bygger din spellista...',
  'home.jukebox_loading_desc': 'Laddar album och spår...',
  'settings.language': 'Språk',
  'settings.language_desc': 'Välj visningsspråk',
  'settings.desktop_full': 'Maestro Connector',
  'settings.desktop_full_desc': 'NAS-bläddring, nätverksspelare, DSP',
  'settings.voice_search': 'Röstsökning',
  'settings.voice_search_desc': 'Aktivera mikrofonen för röstkommandon',
  'settings.ella_voice': 'Ella-röst',
  'settings.ella_voice_desc': 'Vad som händer med musiken när Ella pratar',
  'settings.ella_voice_duck': 'Sänk',
  'settings.ella_voice_pause': 'Pausa',
  'settings.ella_voice_off': 'Av',
  'ellaBans.sectionTitle': 'Blockerade av dig',
  'ellaBans.loading': 'Laddar blockeringar…',
  'ellaBans.empty': 'Inga blockerade spår eller artister ännu.',
  'ellaBans.artistsHeading': 'Artister',
  'ellaBans.tracksHeading': 'Spår',
  'ellaBans.remove': 'Ta bort',
  'ellaBans.unban': 'Ta bort blockering',
  'ellaBans.undo': 'Ångra',
  'ellaRadio.dislike.skipNow': 'Hoppa över just nu',
  'ellaRadio.dislike.neverTrack': 'Spela aldrig det här spåret',
  'ellaRadio.dislike.neverArtist': 'Spela aldrig den här artisten',
  'ellaRadio.banUndoTrack': 'Spelar inte ”{title}” igen',
  'ellaRadio.banUndoArtist': 'Spelar inte {artist} igen',
  'settings.services': 'Tjänster',
  'settings.account': 'Konto',
  'settings.subscription': 'Prenumeration',
  'settings.quick_settings': 'Snabbinställningar',
  'settings.connected': 'Ansluten',
  'settings.connect': 'Anslut',
  'settings.coming_soon': 'Kommer snart',
  'settings.enabled': 'På',
  'settings.disabled': 'Av',
  'help.title': 'Så använder du Maestro',
  'help.intro': 'Maestro är din personliga musikföljeslagare. Här är allt du behöver veta för att få ut det mesta.',
  'help.getting_started': 'Kom igång',
  'help.playing_music': 'Spela musik',
  'help.streaming_services': 'Streamingtjänster',
  'help.your_valet': 'Ella',
  'help.full_featured': 'Bibliotek och nätverksspelare',
  'help.playlists_favorites': 'Spellistor och favoriter',
  'help.close': 'Stäng hjälpen',
  'help.footer': 'Behöver du mer hjälp? Tryck Inställningar → E-posta support för att nå oss.',
  'help.home_label': 'Hem',
  'help.home_desc': 'Din personliga startsida med utvalda förslag, senaste uppspelningar och nya upptäckter.',
  'help.settings_label': 'Inställningar',
  'help.settings_desc': 'Tryck på kugghjulet i sidofältet för att ansluta Qobuz, växla mörkt läge och hantera prenumerationen.',
  'help.search_label': 'Sök',
  'help.search_desc': 'Tryck på förstoringsglaset i sidhuvudet för att söka efter artister, album, spår och spellistor. Röstsökning finns när den är aktiverad i Inställningar.',
  'help.play_track_label': 'Spela ett spår',
  'help.play_track_desc': 'Bläddra till ett album eller en spellista och tryck på ett spår för att börja spela. Minispelaren visas längst ner.',
  'help.mini_player_label': 'Minispelare',
  'help.mini_player_desc': 'Visar aktuellt spår med play/paus, hoppa, förloppsindikator och volym. Tryck på omslaget för att se hela albumet.',
  'help.queue_label': 'Kö',
  'help.queue_desc': 'Tryck länge eller högerklicka på ett spår för att lägga det i kön. Köikonen i minispelaren visar vad som kommer härnäst.',
  'help.qobuz_label': 'Qobuz',
  'help.qobuz_desc': 'Anslut ditt Qobuz-konto i Inställningar för full hi-res-streaming. Utan det hör du 30-sekundersförhandstittar.',
  'help.live_radio_label': 'Live-radio',
  'help.live_radio_desc': 'Aktivera live-radio i Inställningar för att bläddra bland utvalda internetradiostationer.',
  'help.octave_radio_label': 'Octave Radio',
  'help.octave_radio_desc': 'Paul McGowans egen utvalda radiostation — aktivera den i Inställningar.',
  'help.picks_label': 'Personliga val',
  'help.picks_desc': 'Din valet lär sig din smak med tiden och föreslår artister, album och spellistor anpassade för dig.',
  'help.chat_label': 'Chatt',
  'help.chat_desc': 'Tryck på valet-ikonen för att ställa frågor om musik, få rekommendationer eller utforska genrer.',
  'help.trending_label': 'Trendande och nyheter',
  'help.trending_desc': 'Håll dig uppdaterad med det som är populärt och nyutgivet i sidofältet under din valets namn.',
  'help.enable_label': 'Aktivera',
  'help.enable_desc': 'Installera Maestro Connector för NAS-bläddring, val av nätverksspelare och DSP-kontroller.',
  'help.local_lib_label': 'Lokalt bibliotek',
  'help.local_lib_desc': 'Bläddra och spela filer från din NAS eller lokala lagring med Maestro Connector.',
  'help.renderers_label': 'Nätverksspelare',
  'help.renderers_desc': 'Hitta och spela till UPnP/DLNA-spelare i ditt nätverk med Maestro Connector.',
  'help.favorites_label': 'Favoriter',
  'help.favorites_desc': 'Hjärtmarkera en artist, ett album eller ett spår för att spara det i Favoriter.',
  'help.playlists_label': 'Spellistor',
  'help.playlists_desc': 'Bläddra bland utvalda highend-, genre-, stämnings- och säsongsspellistor — eller skapa egna.',
  'help.search_pl_label': 'Sök spellistor',
  'help.search_pl_desc': 'Använd sökikonen bredvid ”Spellistor” i sidofältet för att hitta spellistor efter namn.',
  'search.placeholder': 'Sök musik...',
  'search.voice_search': 'Röstsökning',
  'search.stop_listening': 'Sluta lyssna',
  'search.listening': 'Lyssnar...',
  'search.top_result': 'Bästa träffen',
  'search.try_again': 'Försök igen',
  'search.show_albums': 'Visa album',
  'search.showing_results_for': 'Visar resultat för',
  'search.albums': 'Album',
  'search.artists': 'Artister',
  'search.tracks': 'Spår',
  'search.all': 'Alla',
  'search.playlists': 'Spellistor',
  'search.failed': 'Sökningen misslyckades. Försök igen.',
  'search.no_results': 'Inga spelbara resultat hittades',
  'search.no_results_hint': 'Prova ett annat sökord eller kontrollera dina anslutna tjänster.',
  'search.empty_title': 'Sök i alla dina musiktjänster',
  'search.empty_hint_voice': 'Tala eller skriv för att hitta artister, album och spår',
  'search.empty_hint': 'Skriv för att hitta artister, album och spår',
  'search.back': 'Tillbaka till sökning',
  'search.new_search': 'Ny sökning',
  'search.view_artist': 'Visa hela profilen',
  'player.this_computer': 'Systemljud',
  'player.this_computer_device': 'Den här datorn — {device}',
  'player.this_computer_usb_dac': 'Den här datorn — USB-DAC',
  'player.iphone': 'iPhone',
  'player.system_output': 'Systemutgång',
  'player.renderer_reconnecting': 'återansluter…',
  'player.renderer_unreachable': 'otillgänglig',
  'player.unreachable_play_prompt': '{device} är otillgänglig. Spela till systemljud i stället?',
  'player.unreachable_play_confirm': 'Spela på systemljud',
  'player.unreachable_play_cancel': 'Avbryt',
  'player.audio_output': 'Ljudutgång',
  'player.playback_zone': 'Uppspelningszon',
  'player.scanning': 'Söker efter enheter...',
  'player.play': 'Spela',
  'player.pause': 'Pausa',
  'player.seek': 'Spola',
  'player.volume': 'Volym',
  'player.queue': 'Kö',
  'player.output_device': 'Utgångsenhet',
  'player.single_zone': 'En zon',
  'player.multi_zone': 'Flera zoner',
  'player.master': 'Master',
  'player.zone_volumes': 'Zonvolymer',
  'player.zones_active': '{count} zoner aktiva',
  'player.select_two_zones': 'Välj 2 eller fler zoner',
  'player.multi_zone_count': 'Flera zoner ({count})',
  'player.multi_label': 'Flera',
  'player.playing_on': 'Spelar på {zone}',
  'player.network_renderers': 'Nätverksspelare',
  'player.find_my_dac': 'Hittar du inte din DAC? Ange dess IP-adress',
  'player.find_dac_title': 'Hitta min DAC',
  'player.find_dac_search': 'Sök',
  'player.find_dac_searching': 'Söker...',
  'player.find_dac_found': 'Hittad',
  'player.find_dac_not_found': 'Ingen enhet hittades på den här IP-adressen',
  'player.find_dac_invalid_ip': 'Ange en giltig IP-adress (t.ex. 192.168.1.29)',
  'player.find_dac_hint': 'Hitta DAC:ns IP i dess display eller i routerns enhetslista',
  'player.this_device': 'Systemljud',
  'player.usb_dac': 'USB-DAC',
  'player.usb_dac_connected': 'Ansluten',
  'player.usb_dac_win_hint': 'USB-DAC:n syns inte? Du kan behöva installera tillverkarens drivrutin.',
  'player.local_audio_outputs': 'Lokala ljudutgångar',
  'player.change_output': 'Byt...',
  'player.system_audio_shared_tag': 'Delad — inte bit-perfekt',
  'player.bit_perfect_direct_tag': 'Bit-perfekt (direkt)',
  'player.bit_perfect_direct_tag_suppressed': 'Bit-perfekt (direkt) (tillfälligt av)',
  'player.system_audio_tooltip': 'Systemljud använder datorns delade ljudmixer. Den matchar inte varje albums inbyggda samplingsfrekvens. För bit-perfekt uppspelning, välj din USB-DAC under Bit-perfekt (direkt).',
  'signal_path.badge_shared': 'Delat systemljud',
  'signal_path.badge_shared_tooltip': 'Ljudet spelas genom datorns delade mixer. För högsta kvalitet, välj din ljudenhet direkt i utgångsväljaren.',
  'signal_path.badge_direct': 'Direkt till enhet',
  'signal_path.badge_direct_tooltip': 'Ljudet skickas direkt till din nätverksspelare utan att passera den här datorns mixer.',
  'signal_path.nudge_body': 'Din ljudenhet stöder direktutgång för bättre ljudkvalitet — byta utgång?',
  'signal_path.nudge_show_me': 'Visa mig',
  'signal_path.nudge_not_now': 'Inte nu',
  'player.bit_perfect_picker_hint': 'För bit-perfekt uppspelning som matchar varje albums upplösning, välj din DAC här.',
  'player.bit_perfect_picker_dismiss': 'Uppfattat',
  'exclusive.format_error_title': 'Formatet stöds inte',
  'exclusive.gate_error_title': 'Bit-perfekt-spärren misslyckades',
  'exclusive.switch_system_audio': 'Byt till systemljud',
  'exclusive.bit_perfect': 'Bit-perfekt',
  'exclusive.shared_output': 'Delad',
  'exclusive.fallback_notice': 'Musiken spelas i delat läge — Maestro bytte från bit-perfekt eftersom din DAC inte tog emot {rate} kHz / {depth}-bit på den utgången.',
  'exclusive.fallback_notice_busy': 'Musiken spelas i delat läge — Maestro bytte väg eftersom din DAC används av en annan app. Stäng andra ljudappar för bit-perfekt uppspelning.',
  'exclusive.fallback_toast': 'Musiken spelas i delat läge på {device}. Maestro bytte automatiskt från bit-perfekt för det här spåret.',
  'exclusive.playback_failed_transport': 'Uppspelningen stoppades på {device} — Maestro kunde inte starta delad eller bit-perfekt utgång. Kontrollera DAC-anslutningen och tryck play igen.',
  'dsd.native_dsd_label': 'Native DSD',
  'dsd.dop_supported': 'Ja (upp till {rate} via DoP)',
  'dsd.pcm_only': 'Nej (endast PCM)',
  'dsd.unknown_dac': 'Okänd DAC: använder PCM som standard',
  'dsd.force_pcm': 'Tvinga PCM (inaktivera DoP)',
  'dsd.force_pcm_hint': 'Spela DSD som hi-res PCM i stället för native DSD',
  'common.continue': 'Fortsätt',
  'common.skip': 'Hoppa över',
  'common.skip_step': 'Hoppa över det här steget',
  'common.cancel': 'Avbryt',
  'common.save': 'Spara',
  'common.back': 'Tillbaka',
  'common.close': 'Stäng',
  'common.search': 'Sök',
  'common.menu': 'Meny',
  'common.home': 'Hem',
  'common.help': 'Hjälp',
  'common.about': 'Om Maestro',
  'legal.copyright': '© 2026 pureSAAS LLC. Alla rättigheter förbehållna.',
  'legal.product_of': 'Maestro är en produkt från pureSAAS LLC, Boulder, Colorado.',
  'settings.legal_section': 'Juridisk information',
  'settings.legal_body': 'Maestro tillhandahålls av pureSAAS LLC, ett limited liability company i Colorado.',
  'settings.legal_address': '4865 Sterling Drive, Boulder, CO 80301, USA',
  'about.legal_line': 'Tillhandahålls av pureSAAS LLC · Boulder, Colorado',
  'sidebar.pinOpen': 'Håll sidofältet öppet',
  'sidebar.pinOpenHint': 'Innehållet flyttas för att ge plats',
  'sidebar.pinned': 'Sidofältet är fastnålat',
  'sidebar.pinnedHint': 'Tryck för att återgå till överlägesläge',
  'sidebar.close': 'Stäng sidofältet',
  'onboard.step_of': 'Steg {step} av {total}',
  'onboard.welcome_name': 'Välkommen, {name}!',
  'onboard.welcome_generic': 'Välkommen till Maestro!',
  'onboard.welcome_intro': 'Jag är Paul McGowan, skaparen av Maestro, och jag är glad att du är här.',
  'onboard.welcome_body': 'Maestro är något jag drömt om att bygga i åratal — en musikföljeslagare som är lika vacker att använda som musiken är att höra. Tillsammans ska vi förändra hur du upptäcker, hanterar och njuter av din musik.',
  'onboard.welcome_cta': 'Det är enkelt att komma igång — bara tre snabba steg så lyssnar du.',
  'onboard.step1_title': 'Säkra ditt konto',
  'onboard.step1_desc': 'Välj ett lösenord för att skydda din musik',
  'onboard.step2_title': 'Berätta vad du älskar',
  'onboard.step2_desc': 'Välj genrer och artister så att Maestro känner din smak',
  'onboard.step3_title': 'Anslut din musik',
  'onboard.step3_desc': 'Koppla Qobuz för full hi-res-streaming, eller utforska med förhandstittar',
  'onboard.all_set': 'Du är redo',
  'onboard.account_ready': 'Ditt konto är klart.',
  'onboard.start_step1': 'Vi börjar med steg 1',
  'onboard.choose_password': 'Välj ett lösenord för att säkra ditt konto.',
  'onboard.loading_account': 'Laddar din kontoinformation…',
  'onboard.signed_in_as': 'Inloggad som',
  'onboard.get_started': 'Kom igång →',
  'onboard.label_email': 'E-post',
  'onboard.label_password': 'Lösenord',
  'onboard.label_confirm': 'Bekräfta lösenord',
  'onboard.label_phone': 'Mobilnummer',
  'onboard.phone_helper': 'Glömt lösenordet? Ingen fara — vi skickar en engångskod via sms så att du kommer in igen.',
  'onboard.setting_up': 'Ställer in…',
  'onboard.error_password_length': 'Lösenordet måste vara minst 8 tecken',
  'onboard.error_password_match': 'Lösenorden matchar inte',
  'onboard.choose_language': 'Välj ditt språk',
  'onboard.choose_language_desc': 'Du kan ändra det när som helst i Inställningar.',
  'onboard.genre_title': 'Vilken slags musik älskar du?',
  'onboard.genre_desc': 'Välj minst 3. Det hjälper oss hitta musik du gillar.',
  'onboard.genre_hint_0': 'Välj minst 3 genrer du gillar',
  'onboard.genre_hint_few': '{count} valda — välj {remaining} till',
  'onboard.genre_hint_ready': '{count} valda — fint!',
  'onboard.genre_tap': 'Tryck på dina favoriter för att komma igång',
  'onboard.streaming_title': 'Anslut din musik',
  'onboard.streaming_desc': 'Maestro fungerar bäst med en streamingtjänst, men du kan utforska med gratis förhandstittar.',
  'onboard.favs_title': 'Välj några favoriter',
  'onboard.favs_desc': 'Vi använder dem för att anpassa din startsida.',
  'onboard.complete_title': 'Du är redo!',
  'onboard.complete_desc': 'Maestro är redo att leda din perfekta lyssnarupplevelse.',
  'onboard.start_listening': 'Börja lyssna →',
  'onboard.saving': 'Sparar dina inställningar…',
  'onboard.i_like_everything': 'Jag gillar allt',
  'onboard.almost_there': 'Nästan klart!',
  'onboard.experience_maestro': 'Du är på väg att uppleva Maestro!',
  'onboard.favs_hint_0': 'Välj några artister du älskar',
  'onboard.favs_hint_few': '{count} valda — välj {remaining} till',
  'onboard.favs_hint_ready': '{count} valda — god smak!',
  'onboard.almost_done': 'Nästan klart!',
  'onboard.preview_note': 'Du hör 30-sekundersförhandstittar av varje spår.\nAnslut en tjänst när som helst för att höra hela låtar.',
  'tour.skip': 'Hoppa över rundturen',
  'tour.next': 'Nästa →',
  'tour.start_exploring': 'Börja utforska →',
  'tour.section_browse': 'Bläddra',
  'tour.section_services': 'Tjänster',
  'tour.section_valet': 'Ella',
  'tour.settings_title': 'Inställningar',
  'tour.settings_body': 'Välj streamingtjänster, anpassa temafärger och hantera prenumerationen.',
  'tour.home_title': 'Hem',
  'tour.home_body': 'Din personliga musiköversikt. Album, spellistor och rekommendationer utifrån din smak.',
  'tour.genres_title': 'Genrer',
  'tour.genres_body': 'Bläddra i musik efter genre. Upptäck nya album inom jazz, klassiskt, rock och mer.',
  'tour.qobuz_title': 'Qobuz',
  'tour.qobuz_body': 'Din hi-res-streamingtjänst. Bläddra bland miljoner spår i enastående kvalitet — eller njut av 30-sekundersförhandstittar.',
  'tour.valet_title': 'Ellas val',
  'tour.valet_body': 'Ella är din personliga musikvalet. Hon lär sig vad du älskar och föreslår album du kommer att gilla. Ju mer du lyssnar, desto bättre känner hon dig.',
  'tour.radio_title': 'Live-radio',
  'tour.radio_body': 'Tusentals stationer från hela världen, nära till hands. Jazz, klassiskt, världsmusik och mer.',
  'tour.done_title': 'Ha så kul! 🎶',
  'tour.done_body': 'Du är redo att utforska. Upptäck, lyssna och njut av din musik som aldrig förr.',
  'smart.title': '{valetName}s val',
  'smart.ask_ella': 'Fråga {valetName}',
  'smart.tell_ella': 'Berätta för {valetName} vad du vill höra',
  'smart.type_request': 'Eller skriv din förfrågan här...',
  'smart.cancel': 'Avbryt',
  'smart.create': 'Skapa',
  'smart.creating': 'Skapar...',
  'smart.crafting': '{valetName} skapar din spellista...',
  'smart.crafting_sub': 'Hittar de rätta spåren och sätter ihop flödet',
  'smart.ella_acknowledged': 'Tack! Jag har dina instruktioner. Ge mig en minut att bygga din spellista.',
  'smart.no_playlists': 'Inga spellistor ännu',
  'smart.no_playlists_sub': 'Be {valetName} skapa en — beskriv stämningen, tillfället, och låt henne bygga din resa.',
  'smart.play_all': 'Spela alla',
  'smart.talk_to_ella': 'Redigera den här spellistan',
  'smart.tell_change': 'Berätta för {valetName} vad som ska ändras...',
  'smart.fixing': 'Skickar...',
  'smart.ella_thinking': '{valetName} tänker...',
  'smart.changes_applied': 'Här är vad som ändrades',
  'smart.happy_with_this': 'Nöjd med det här?',
  'smart.keep_changes': 'Ser bra ut',
  'smart.try_different': 'Inte riktigt',
  'smart.rename': 'Byt namn',
  'smart.fix_it': 'Skicka',
  'smart.back': 'Tillbaka',
  'smart.tracks': 'spår',
  'smart.min': 'min',
  'smart.score': 'Poäng',
  'smart.match': 'träff',
  'smart.refined': 'förfinad',
  'smart.listening': 'Lyssnar...',
  'smart.not_found': 'Spellistan hittades inte',
  'smart.error_generate': 'Förlåt, jag hade svårt att sätta ihop det. Kan du försöka igen?',
  'smart.loved': 'Älskade',
  'smart.disliked': 'Inte för mig',
  'smart.created': 'Skapad {date}',
  'smart.revised': 'Reviderad {date}',
  'smart.save_to_library': 'Spara i Mina spellistor',
  'smart.saved_to_library': 'Sparad i Mina spellistor',
  'smart.delete_or_replace': 'Ta bort eller ersätt det här spåret?',
  'smart.delete_track': 'Ta bort',
  'smart.replace_track': 'Ersätt',
  'smart.edit_or_delete': 'Vad vill du göra med det här spåret?',
  'smart.edit_track': 'Redigera',
  'smart.replace_ask': 'Inga problem. Vilken slags spår vill du ersätta det här med?',
  'smart.replace_working': 'Okej, jag tar det.',
  'smart.replace_done': 'Säg till om det här var vad du ville ha.',
  'smart.add_to_my_playlists': 'Lägg till i Mina spellistor',
  'smart.added_to_playlists': 'Tillagd!',
  'smart.review_title': 'Granska din spellista',
  'smart.looks_good': 'Ser bra ut — spela den!',
  'smart.send': 'Skicka',
  'smart.try_again': 'Försök igen',
  'qobuz.playlists.title': 'Qobuz-spellistor',
  'qobuz.playlists.description': 'Kopiera dina Qobuz-spellistor till Mina spellistor så att du kan redigera dem och så att Maestro kan lära sig din smak.',
  'qobuz.playlists.refresh': 'Uppdatera Qobuz-spellistor',
  'qobuz.playlists.importing': 'Importerar…',
  'qobuz.playlists.complete': 'Lade till {added}, uppdaterade {updated}.',
  'qobuz.playlists.preservedEdited': '{n} redigerade i Maestro behölls.',
  'qobuz.playlists.error': 'Importen misslyckades.',
  'tweak_title': 'Justera stationen',
  'tweak_btn': 'Justera',
  'tweak_tune_btn': 'Finjustera',
  'tweak_queue_btn': 'Kö',
  'queue_shuffle': 'Blanda kommande',
  'queue_shuffle_disabled_radio': 'Ella arrangerar den här stationens flöde',
  'ella_build_finding_opener': 'Hittar din öppning…',
  'ella_build_shaping': 'Formar setet…',
  'ella_build_still_shaping': 'Formar fortfarande setet…',
  'ella_build_connectivity': 'Har svårt att nå Maestro — försöker igen…',
  'ella_build_partial': 'Kunde inte slutföra hela setet — din station fortsätter med det som ligger i kön.',
  'ella_radio_preparing_station': 'Ella förbereder din station…',
  'ella_radio_stall_warning': 'Stationsbygget tar längre tid än vanligt.',
  'ella_radio_retry_build': 'Försök bygga igen',
  'tweak_placeholder': 'Berätta för Ella hur stationen ska justeras…',
  'tweak_examples_label': 'Prova till exempel:',
  'tweak_example_1': 'Ingen musik äldre än 10 år',
  'tweak_example_2': 'Fler dolda pärlor, färre hits',
  'tweak_example_3': 'Håll det lugnt och akustiskt',
  'tweak_example_4': 'Lägg till fler kvinnliga sångare',
  'fda.title': 'Maestro behöver behörighet att komma åt ditt musikbibliotek',
  'fda.description': 'macOS tog bort Maestros filbehörighet, troligen efter den senaste appuppdateringen. Ditt musikbibliotek är okej — vi behöver bara ge åtkomst igen.',
  'fda.play_description': 'Maestro behöver Full Disk Access för att spela filer från den här disken. Öppna Systeminställningar, aktivera Maestro Connector under Integritet och säkerhet → Full Disk Access och försök igen.',
  'fda.open_settings': 'Öppna Systeminställningar',
  'fda.recheck': 'Jag har gett åtkomst — kontrollera igen',
  'source_health.offline_disconnected': 'Offline i {minutes} min — disken frånkopplad',
  'source_health.offline_timeout': 'Offline i {minutes} min — långsamt svar',
  'source_health.toast_offline': 'Uppspelningen stoppades — det här spåret ligger på ”{source_name}”, som är offline. Maestro behöll biblioteksposten. Anslut disken eller delningen igen och tryck play.',
  'source_health.toast_permission': 'Uppspelningen stoppades — Maestro kan inte läsa ”{source_name}” just nu. Kontrollera mappbehörigheter i Systeminställningar och tryck play igen.',
  'source_health.empty_folders_one': '1 mapp innehåller ingen musik',
  'source_health.empty_folders_many': '{count} mappar innehåller ingen musik',
  'library_health.benign_empty': 'Ditt bibliotek byggs fortfarande — den första skanningen pågår. Allt är i sin ordning; det löser sig när skanningen är klar.',
  'library_health.genuine_warning': 'Hälsokontrollen för det lokala biblioteket misslyckades. Starta om Maestro; om det kvarstår, använd Inställningar → Spara loggar på skrivbordet och skicka dem till oss.',
  'faq.title': 'Vanliga frågor',
  'faq.subtitle': 'Snabba svar på vanliga frågor',
  'faq.empty': 'Inga vanliga frågor tillgängliga ännu.',
  'faq.loading': 'Laddar…',
  'faq.bit_perfect_output.q': 'Systemljud mot bit-perfekt (direkt) — vad är skillnaden?',
  'faq.bit_perfect_output.a': 'Systemljud skickar musiken genom datorns delade ljudmixer. Windows eller macOS väljer en fast samplingsfrekvens och omsamplar allt — din DAC ser aldrig albumets inbyggda frekvens, så uppspelningen är inte bit-perfekt.\n\nBit-perfekt (direkt) går förbi mixern helt. Maestro öppnar din USB-DAC i exklusivt läge och sätter inbyggd frekvens och bitdjup för varje album (till exempel 44,1 kHz / 16-bit på ett album, 96 kHz / 24-bit på nästa).\n\nPå Windows med Maestro Connector v11.0.113 eller nyare väljs din USB-DAC automatiskt när den är ansluten. Om du är på systemljud eller en äldre version, öppna enhetsväljaren i spelfältet, hitta din DAC under Bit-perfekt (direkt) och välj den. För att medvetet använda den delade vägen (till exempel när exklusivt läge inte finns), välj Systemljud — den är märkt Delad — inte bit-perfekt.',
  'support.message_paul': 'Meddela Paul',
  'support.goes_to': 'Går till support@maestromusic.app — Paul får kopia på varje ärende',
  'support.intro': 'Maestro är det främsta programmet för att låsa upp musikens magi — och vi bygger något särskilt tillsammans. Det är ett arbete under utveckling, stöttat av vår community, och vi är här för att göra varje lyssning till ett nöje. Jag vill gärna höra dina kommentarer, felrapporter och idéer — varje meddelande kommer rakt till mig.',
  'support.name': 'Namn',
  'support.name_placeholder': 'Ditt namn',
  'support.email': 'E-post',
  'support.email_placeholder': 'din@epost.se',
  'support.subject': 'Ämne',
  'support.subject_placeholder': 'Vad tänker du på?',
  'support.message': 'Meddelande',
  'support.message_placeholder': 'Berätta vad du har på hjärtat...',
  'support.platform': 'Plattform',
  'support.send': 'Skicka meddelande',
  'support.sending': 'Skickar…',
  'support.sent': 'Meddelandet skickat ({ticketId})! Du får ett bekräftelsemejl och kan följa vår konversation nedan.',
  'support.version': 'Version',
  'support.diagnostic.title': 'Diagnosläge',
  'support.diagnostic.checking': 'Kontrollerar…',
  'support.diagnostic.state_a_body': 'Om Maestro-support har bett dig slå på diagnostisk loggning kan du aktivera det här. Det delar anslutningsuppgifter med vårt team för att hjälpa till att felsöka.',
  'support.diagnostic.contact_support': 'Kontakta support för att aktivera',
  'support.diagnostic.state_b_body_ticket': 'Diagnostisk loggning är tillgänglig för ditt supportärende {ticket}.',
  'support.diagnostic.state_b_body': 'Diagnostisk loggning är tillgänglig.',
  'support.diagnostic.state_c_instruction': 'Diagnostikdata spelas in. Använd Maestro som vanligt tills problemet uppstår, kom sedan tillbaka hit och skicka loggen.',
  'support.diagnostic.available_expires': 'Tillgänglig — går ut {time}',
  'support.diagnostic.recording_expires': 'Spelar in — går ut {time}',
  'support.diagnostic.send_log': 'Skicka logg',
  'support.diagnostic.sending': 'Skickar…',
  'support.diagnostic.log_sent': 'Logg skickad till support',
  'support.diagnostic.reference': 'referens',
  'support.diagnostic.send_failed': 'Kunde inte skicka loggen. Försök igen.',
  'support.diagnostic.expired': 'utgången',
  'auth.community.headline': 'Ditt musiksystem. Äntligen gjort rätt.',
  'auth.community.body': 'Varje musikapp du använt tidigare gjorde en kompromiss som du antagligen inte kunde sätta ord på men alltid kände. Något saknades — luften runt instrumenten, tyngden i en bastrumma, känslan av att du var där.\n\nMaestro finns för att vi bestämde att det inte var tillräckligt bra.\n\nByggt från grunden för oslagbar ljudkvalitet: hi-res-streaming och ditt lokala bibliotek, från NAS till vardagsrum, med den transparens och dynamik som får stora inspelningar att kännas verkliga.\n\nFör samlare med seriösa bibliotek ger Maestro det djup av kontroll som krävande lyssnare velat ha i åratal — nytänkt för idag. Peka det mot din NAS, nätverksdelningar eller diskar i ditt hemnätverk. Bläddra i samlingar av alla storlekar med en kraftfull mediadatabas byggd för att organisera, tagga och navigera enorma bibliotek så som du faktiskt tänker på musik — efter artist, format, genre eller egna fält. Rik metadata, flexibla vyer och biblioteksverktyg som lägger varje fil du äger inom räckhåll.\n\nFull kontroll över biblioteket, uppspelning i flera rum och musikhantering utformad kring lyssnandet — streaming och lokalt, tillsammans på ett ställe.\n\nStreamingappen och musiksystemet som seriösa lyssnare har väntat på.',
  'auth.signup.subtitle': 'Starta din 30-dagars gratisperiod — inget kort krävs.',
  'auth.signin.subtitle': 'Välkommen tillbaka. Din musik väntar.',
  'auth.sessionReachabilityNotice': 'Maestro kan inte nå din sparade session på den här enheten. Logga in igen för att återställa bibliotek och inställningar.',
  'auth.sessionBootstrapFailed': 'Kan inte nå din sparade session — försök igen eller logga in på nytt',
  'auth.sessionBootstrapRetry': 'Försök igen med sessionen',
  'auth.boot.stillConnecting': 'Ansluter fortfarande — du kan logga in på nytt',
  'auth.boot.daemonUnreachable': 'Maestro kan inte nå bakgrundstjänsten på den här enheten. Logga in för att ansluta på nytt.',
  'auth.boot.signInNow': 'Logga in',
  'auth.reauthRequired.title': 'Logga in igen',
  'auth.reauthRequired.body': 'Din session behövde förnyas av säkerhetsskäl. Logga in för att fortsätta — bibliotek, favoriter och inställningar är orörda.',
  'auth.emailConfirmed.headline': 'Välkommen till Maestro.',
  'auth.emailConfirmed.body': 'Ditt konto är klart. Anslut dina streamingtjänster, lägg till ditt lokala bibliotek och börja lyssna.',
  'auth.interstitial.body': 'Tack för att du gick med. Maestro är Paul McGowans livsverk — ett musiksystem byggt för oslagbar ljudkvalitet, full kontroll över det lokala biblioteket, hi-res-streaming och seriös musikhantering. Öppna Maestro på din Mac eller Windows-dator för att börja.',
  'auth.footer.tagline': 'Byggt av Paul. I jakten på anmärkningsvärt ljud.',
  'wizard.build_reading_brief': 'Maestro läser din beskrivning',
  'wizard.build_choosing_territory': 'Väljer territorium — {count} artister',
  'wizard.build_finding_tracks': 'Hittar spår — {current} av {target} · {eta}',
  'wizard.build_building': 'Maestro bygger din spellista…',
  'wizard.build_still_shaping': 'Bygger fortfarande din spellista — spår visas när de är redo…',
  'wizard.playing_while_finishing': 'Spelar medan Maestro slutför',
};

export default sv;
